var getInstallmentQuantity = function getInstallmentQuantity(data) {
  var _data$installment, _data$installment2;
  return (data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.quantity) ? "parcelas-".concat(data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) : undefined;
};
export default getInstallmentQuantity;